<template lang="pug">
    div
        //- code {{ givenSearchFilters }} 
        Row.selectorRow(v-if="selector.includes('groupName')")
            Col(span="6") 
                Strong {{ $t('global.select') }} {{ $t('domainsetting.groupName') }}
            Col(span="18")
                FormSelect(
                    v-model="formData.groupName" 
                    :formData="formData" 
                    :formItem="groupNameSelectorOptions" 
                    @input="onSelectedGroupNameChanged"
                    style="width:200px"
                )
        Row.selectorRow(v-if="selector.includes('appProfileName')")
            Col(span="6")
                Strong {{ $t('global.select') }} {{ $t('domainsetting.appProfileName') }}
            Col(span="18")
                FormSelect(
                    v-model="formData.appProfileName" 
                    :formData="formData" 
                    :formItem="appProfileNameSelectorOptions" 
                    @input="onSelectedAppProfileNameChanged"
                    style="width:200px"
                )
        Row.selectorRow(v-if="selector.includes('serviceGroupName')")
            Col(span="6")
                Strong {{ $t('global.select') }} {{ $t('domainsetting.serviceGroupName') }}
            Col(span="18")
                FormSelect(
                    v-model="formData.serviceGroupName" 
                    :formData="formData" 
                    :formItem="serviceGroupNameSelectorOptions" 
                    @input="onSelectedServiceGroupNameChanged"
                    style="width:200px"
                )
        Row.selectorRow()
            Col(span="6")
                Strong {{ $t('global.select') }} {{ $t('domainsetting.tags') }}
            Col(span="18")
                FormSelect(
                    v-model="formData.tags" 
                    :formData="formData" 
                    :formItem="tagsSelectorOptions" 
                    @input="onSelectedTagChanged"
                    style="width:200px"
                )
        Row.selectorRow(v-if="selector.includes('servername')")
           Col(span="6")
                Strong {{ $t('global.select') }} {{ esIndex == 'rcm-app-profiles' ?$t('domainsetting.appProfileName'): $t('domainsetting.servername') }}
           Col(span="18")
               Input(
                   search
                   placeholder="input to search"
                   v-model="inputServername"
                   @on-enter="getItems()"
                   @on-search="getItems()"
                   @on-change="listenClear(inputServername)"
                   :disabled="!formData.groupName"
                   style="width: auto; margin-right: 5px")
        Row.selectorRow(v-if="selector.includes('servername')")
        Divider
        virtual-table(
                :data="tableData"
                :columns="tableColumns"
                :minWidth="600"
                ref="fqdnTable"
                @on-selection-change="handleSelectRow"
                )
        Page(
            :total="tableDataTotal" 
            :page-size="pageSize" 
            :current="pageCurrent"
            @on-change="changePage"
            show-total
            style="margin-top: 8px"
        )
            span Select {{ selectedItems.length }} of {{ tableDataTotal }} items
        Divider
</template>

<script>
import { getFormOptions } from "@/api/formoptions";
import { getEsData } from "@/api/esdata";

import VirtualTable from "@/components/VirtualTable";
import FormSelect from "@/components/rcmTableFormItems/Select/index.js";

export default {
    name: "FQDNSelector",
    components: {
        VirtualTable,
        FormSelect
    },
    data() {
        return {
            formData: {
                groupName: "",
                serviceGroupName: [],
                appProfileName: [],
                tags: []
            },

            inputServername: "",
            selectedItems: [],
            tableColumns: [
                {
                    type: "selection",
                    width: 60,
                    align: "center"
                },
                {
                    title:
                        this.esIndex == "rcm-app-profiles"
                            ? this.$i18n.t("domainsetting.appProfileName")
                            : this.$i18n.t("domainsetting.servername"),
                    key: this.esIndex == "rcm-app-profiles" ? "appProfileName" : "servername"
                },
                { title: "Tags", key: "tags" },
                { title: "Origins", key: "origins" }
            ],
            tableData: [],
            tableDataTotal: 0,
            loading: false,
            pageSize: 300,
            pageCurrent: 1,

            // esIndex: "rcm-nginxconfigs",

            groupNameSelectorOptions: {
                placeholder: this.$i18n.t("domainsetting.groupName"),
                options: [],
                remoteOptions: async (queryValue, queryParams) => {
                    queryValue = queryValue || "*";
                    queryParams.groupNames = `*${queryValue}*`;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`groupnames?${queryString}`);
                    return result.data.options;
                },
                queryParamsFields: [],
                defaultVal: "",
                disabled: this.$store.state.queryGroupName !== "all"
            },
            serviceGroupNameSelectorOptions: {
                placeholder: this.$i18n.t("domainsetting.serviceGroupName"),
                options: [],
                optionStyle: 2,
                remoteOptions: async (queryValue, queryParams) => {
                    queryValue = queryValue || "*";
                    queryParams.serviceGroupNames = `*${queryValue}*`;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`servicegroupnames?${queryString}`);
                    return result.data.options;
                },
                queryParamsFields: [{ fieldName: "groupName", queryIf: val => val !== "" }],
                defaultVal: "",
                disabled: () => this.formData.groupName == "all"
            },
            appProfileNameSelectorOptions: {
                placeholder: this.$i18n.t("domainsetting.appProfileName"),
                options: [],
                optionStyle: 2,
                // remoteOptions: async (queryValue, queryParams) => {
                //     queryValue = queryValue || "*";
                //     queryParams.serviceGroupNames = `*${queryValue}*`;
                //     let queryString = new URLSearchParams(queryParams).toString();
                //     let result = await getFormOptions(`app-profilenames?${queryString}`);
                //     return result.data.options;
                // },
                // queryParamsFields: [{ fieldName: "groupName", queryIf: val => val !== "" }],
                // defaultVal: "",
                disabled: () => true
            },
            tagsSelectorOptions: {
                placeholder: this.$i18n.t("domainsetting.tags"),
                multiple: true,
                remoteOptions: async (queryValue, queryParams) => {
                    queryValue = queryValue || "*";
                    queryParams.tags = `*${queryValue}*`;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`/groupby/tags?indexName=${this.esIndex}&${queryString}`);
                    return result.data.options;
                },
                queryParamsFields: [{ fieldName: "groupName", queryIf: val => val !== "" }],
                options: [],
                defaultVal: [],
                disabled: () => this.formData.groupName == "all"
            }
        };
    },
    props: {
        selector: {
            default: () => ["groupName", "serviceGroupName", "appProfileName", "servername"]
        },
        givenSearchFilters: { default: () => [] },
        esIndex: { type: String, default: "" },
        action: { type: String, default: "" } 
    },
    watch: {
        selectedItems: function(newVal, oldVal) {
            // console.log(newVal, oldVal, "selectedItems");
            this.$emit("input", {
                selectedGroupName: this.formData.groupName,
                selectedItems: newVal
            });
        }
    },
    created() {},
    mounted() {
        this.$emit("input", {
            selectedGroupName: "",
            selectedItems: []
        });
        this.givenSearchFilters.forEach(filter => {
            this.formData[filter.key] = filter.value;
        });
    },
    methods: {
        getItems() {
            this.loading = true;
            this.selectedItems = [];
            getEsData(this.searchOptions)
                .then(res => {
                    this.tableData = res.data.mapData;
                    this.tableDataTotal = res.data.total;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        listenClear(val) {
            if (val == "") {
                this.getItems();
            }
        },
        handleSelectRow(selectedItems) {
            if (this.esIndex == "rcm-app-profiles") {
                this.selectedItems = selectedItems.map(e => e.appProfileName);
            } else {
                this.selectedItems = selectedItems.map(e => e.servername);
            }
        },
        changePage(page) {
            this.pageCurrent = page;
            this.getItems();
        },

        onSelectedGroupNameChanged() {
            // 清空選取
            this.formData.serviceGroupName = [];
            this.formData.tags = [];
            this.selectedItems = [];
            this.getItems();
        },
        onSelectedServiceGroupNameChanged() {
            // 清空選取
            this.selectedItems = [];
            this.getItems();
        },
        onSelectedAppProfileNameChanged() {
            // 清空選取
            this.selectedItems = [];
            this.getItems();
        },
        onSelectedTagChanged() {
            // 清空選取
            this.selectedItems = [];
            this.getItems();
        }
    },
    computed: {
        searchFilters() {
            let filters = [];
            if (this.formData.groupName.length > 0) {
                filters.push({
                    key: "groupName",
                    type: "string",
                    value: this.formData.groupName
                });
            }
            if (this.formData.appProfileName.length > 0) {
                filters.push({
                    key: "appProfileName",
                    type: "string",
                    value: this.formData.appProfileName
                });
            }
            if (this.formData.serviceGroupName.length > 0) {
                filters.push({
                    key: "serviceGroupName",
                    type: "string",
                    value: this.formData.serviceGroupName
                });
            }
            if (this.formData.tags.length > 0) {
                filters.push({
                    key: "tags",
                    type: "string",
                    value: this.formData.tags
                });
            }
            if (this.inputServername.length > 0) {
                filters.push({
                    key: this.esIndex == "rcm-app-profiles" ? "appProfileName" : "servername",
                    type: "string",
                    value: `*${this.inputServername}*`
                });
            }
            // filters = filters.concat(this.givenSearchFilters);
            return filters;
        },
        searchOptions() {
            var options = {
                isFuzzySearch: false,
                esIndex: this.esIndex,
                from: this.pageSize * (this.pageCurrent - 1),
                size: this.pageSize,
                sort:
                    this.esIndex == "rcm-app-profiles"
                        ? [{ "appProfileName.keyword": { order: "asc" } }]
                        : [{ "servername.keyword": { order: "asc" } }],
                filters: this.searchFilters,
                searchView: "FQDNSelector",
                action: this.action
            };
            return options;
        }
    },
    beforeDestroy() {
        this.$emit("input", {
            selectedGroupName: "",
            selectedItems: []
        });
    }
};
</script>
<style>
.selectorRow {
    margin: 10px 5px 10px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/FQDNSelector.vue